import { StabilityCheckItem } from "./types";

const getEnvironment = () =>
    window.env.NODE_ENV === "development" ? "dev" : "prod";

const createBaseChecks = (nameCustomer: string): StabilityCheckItem[] => {
    const environment = getEnvironment();

    return [
        {
            url: `https://monitor-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://mobilidade-api-node-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
            expectedBody: "Hello World!",
        },
        {
            url: `https://mobilidade-api-php-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 401,
        },
        {
            url: `https://mobilidade-monitorapiv2-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://monitor-new-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://${nameCustomer}-mobilidade.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://${nameCustomer}-new.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
    ];
};

const createCentralChecks = (nameCustomer: string): StabilityCheckItem[] => {
    const environment = getEnvironment();

    return [
        {
            url: `https://central-${nameCustomer}-api.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://central-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
    ];
};

const createDeliveryChecks = (nameCustomer: string): StabilityCheckItem[] => {
    const environment = getEnvironment();

    return [
        {
            url: `https://delivery-api-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://delivery-realtimeapi-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
        {
            url: `https://delivery-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
    ];
};

const createLiteChecks = (nameCustomer: string): StabilityCheckItem[] => {
    const environment = getEnvironment();

    return [
        {
            url: `https://lite-${nameCustomer}.${environment}.704apps.com.br/`,
            expectedStatus: 200,
        },
    ];
};

function filterLinksStabilityModal(
    modulesActive: ModulesCustomerProps[],
    nameCustomer: string
) {
    if (!modulesActive?.length || !nameCustomer) {
        return [];
    }

    const checksMap = new Map<string, StabilityCheckItem>();
    const addChecks = (checks: StabilityCheckItem[]) => {
        checks.forEach((check) => {
            checksMap.set(check.url, check);
        });
    };

    if (modulesActive.find((data) => data.description === "Todos")) {
        addChecks(createBaseChecks(nameCustomer));
        addChecks(createCentralChecks(nameCustomer));
        addChecks(createDeliveryChecks(nameCustomer));
    }

    if (modulesActive.find((data) => data.description === "Central")) {
        addChecks(createCentralChecks(nameCustomer));
    }

    if (modulesActive.find((data) => data.description === "Delivery")) {
        addChecks(createDeliveryChecks(nameCustomer));
    }

    if (modulesActive.find((data) => data.description === "Lite")) {
        addChecks(createLiteChecks(nameCustomer));
    }

    return Array.from(checksMap.values());
}

export { filterLinksStabilityModal };
